<template>
  <div>
    <v-data-table
      fixed-header
      dense
      :height="groupBy.length ? 530 : 470"
      :group-by="groupByValue"
      :custom-group="customGroupBy"
      :items="filteredHistory"
      :headers="headers"
      :hide-default-footer="!!groupBy.length"
      :disable-pagination="!!groupBy.length"
      :footer-props="{
            'items-per-page-options': [20, 30, 50, -1]
      }"
    >
      <template v-slot:[`group.header`]="{ items, isOpen, toggle, headers }">
        <td
          v-if="fromRequestModule"
          :colspan="headers.length - 5"
          class="primary white--text group-td"
        >
          <div class="d-flex align-center">
            <v-btn
              icon
              small
              @click="toggle"
            >
              <v-icon color="white">
                {{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </v-btn>
            <span class="subtitle-2 ml-2">{{ groupTitle(items[0]) }}</span>
          </div>
        </td>
        <td
          :colspan="2"
          class="primary white--text text-no-wrap px-2"
        >
          <div class="d-flex align-center">
            <span>Total: {{ totalAmount(items) }}$</span>
          </div>
        </td>
        <td
          :colspan="3"
          class="primary white--text text-no-wrap px-2"
        >
          <div class="d-flex align-center">Amount : {{ items.length }}</div>
        </td>
      </template>
      <template v-slot:[`item.Is_Pending`]="{ item }">
        <span
          v-if="item.Status === statusNames.Pending"
          class="orange--text darken-2"
        >
          Pending
        </span>
        <span
          v-if="!item.Is_Pending"
          class="primary--text darken-2"
        >
          Considered
        </span>
      </template>
      <template v-slot:[`item.Approved`]="{ item }">
        <span
          v-if="item.Status === statusNames.Approved"
          class="success--text darken-2"
        >
          Approved by {{ item.Confirmer_Full_Name }}
        </span>
        <span
          v-if="item.Status === statusNames.Rejected"
          class="error--text darken-2"
        >
          Rejected by {{ item.Confirmer_Full_Name }}
          <b>Reason: {{ item.Rejection_Reason }}</b>
        </span>
      </template>
      <template v-slot:[`item.Payment_File_Name`]="{ item }">
        <a
          @click="getCompensationFile(item.Payment_File_Name, item.Request_ID, 'Payment_File', item.Payment_File_Mimetype)"
        >{{ item.Payment_File_Name }}</a>
      </template>
      <template v-slot:[`item.Agreement_File_Name`]="{ item }">
        <a
          @click="getCompensationFile(item.Agreement_File_Name, item.Request_ID, 'Agreement_File', item.Agreement_File_Mimetype)"
        >{{ item.Agreement_File_Name }}</a>
      </template>
      <template v-slot:[`item.Amount`]="{ item }">
        <span>
          {{ item.Amount + ' $' }}
        </span>
      </template>
      <template v-slot:[`item.Payout_Month`]="{ item }">
        <span v-if="fromRequestModule" class="d-flex margin-top--10">
          <DatePicker
            v-model="item.Payout_Month"
            :disabled="!item.Approved"
            type="month"
            @onDatePickerChange="updatePayoutMonth(item)"
          />
        </span>
        <span v-else>
          {{ item.Payout_Month }}
        </span>
      </template>
      <template v-slot:[`item.Edit_Manage`]="{ item }">
        <td class="text-center text-no-wrap">
        <template>
          <v-tooltip bottom color="info">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                :disabled="!item.Is_Pending"
                v-bind="attrs"
                v-on="on"
                color="info"
                @click="openRequest(item)"
              >
                <v-icon> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom color="red darken-2">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                :disabled="!item.Is_Pending"
                v-bind="attrs"
                v-on="on"
                color="red darken-2"
                @click="openDeleteDialog(item)"
              >
                <v-icon> mdi-delete </v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </template>
      </td>
      </template>
      <template v-slot:[`item.Manage`]="{ item }">
        <td class="text-center text-no-wrap">
        <template v-if="item.Is_Pending">
          <v-tooltip bottom color="success">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                v-bind="attrs"
                v-on="on"
                color="success"
                @click="openAcceptDialog(item)"
              >
                <v-icon> mdi-check-circle </v-icon>
              </v-btn>
            </template>
            <span>Approve</span>
          </v-tooltip>
          <v-tooltip bottom color="red darken-2">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                v-bind="attrs"
                v-on="on"
                color="red darken-2"
                @click="openRejectDialog(item)"
              >
                <v-icon> mdi-close-circle </v-icon>
              </v-btn>
            </template>
            <span>Reject</span>
          </v-tooltip>
        </template>
        <template v-else>
          <v-tooltip bottom color="blue darken-2">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                v-bind="attrs"
                v-on="on"
                color="blue darken-2"
                @click="openPendingDialog(item)"
              >
                <v-icon> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>To pending</span>
          </v-tooltip>
        </template>
        </td>
      </template>
    </v-data-table>
    <v-dialog
      v-model="showRejectDialog"
      max-width="300px"
    >
      <v-card>
        <v-card-title>
          <v-textarea
            rows="2"
            label="Rejection reason"
            v-model="rejectionReason"
          ></v-textarea>
        </v-card-title>
        <v-card-actions>
          <v-btn
            small
            outlined
            color="primary"
            @click="showRejectDialog = false"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            small
            :disabled="!rejectionReason"
            color="red darken-2 white--text"
            @click="considerRequest(false)"
          >
            Reject
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showPendingDialog"
      max-width="300px"
    >
      <v-card>
        <v-card-title>
          <v-textarea
            rows="2"
            label="Pending reason"
            v-model="pendingReason"
          >
          </v-textarea>
        </v-card-title>
        <v-card-actions>
          <v-btn small outlined color="primary" @click="showPendingDialog = false">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small :disabled="!pendingReason" color="blue darken-2 white--text" @click="considerRequest(false)">
            To pending
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="showAcceptDialog"
      v-model="showAcceptDialog"
      :mode="confirmOrDeniedDialogModes.confirmation"
      :message="'Approve request?'"
      :confirmBtnName="'Approve'"
      @onApproveClick="considerRequest(true)"
      @onCancelClick="showAcceptDialog = false"
      @onCloseClick="showAcceptDialog = false"
    />
    <ConfirmOrDeniedDialog
      v-if="showDeleteDialog"
      v-model="showDeleteDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      @onDeleteClick="deleteRequest"
      @onCancelClick="showDeleteDialog = false"
      @onCloseClick="showDeleteDialog = false"
    />
    <ExpenditureCompensationRequest
      v-if="requestForExpenditureCompensationDialog"
      v-model="requestForExpenditureCompensationDialog"
      :requestId="requestForExpenditureCompensationId"
      @getHistory="getHistory"
    />
  </div>
</template>
<script>
export default {
  name: 'ExpenditureCompensationRequestHistory',
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue'),
    DatePicker: () => import('@/components/global/DatePicker.vue'),
    ExpenditureCompensationRequest: () => import('@/components/employee/employee_requests/ExpenditureCompensationRequest.vue')
  },
  props: {
    value: {
      required: false,
      default: false,
      type: Boolean
    },
    employeeId: {
      required: false,
      default: null
    },
    dateFrom: {
      required: false,
      default: null
    },
    dateTo: {
      required: false,
      default: null
    },
    groupBy: {
      required: false,
      default: () => {
        return []
      }
    },
    fromRequestModule: {
      required: false,
      default: false
    },
    showListEmployee: {
      required: false,
      default: false
    },
    filterBySubcategory: {
      required: false,
      default: null
    }
  },
  data () {
    return {
      history: [],
      consideringRequest: null,
      showRejectDialog: false,
      showAcceptDialog: false,
      rejectionReason: null,
      showPendingDialog: false,
      showDeleteDialog: false,
      requestForExpenditureCompensationDialog: false,
      requestForExpenditureCompensationId: null,
      pendingReason: null,
      downloadLink: document.createElement('a'),
      statusNames: {
        Pending: 'Pending',
        Rejected: 'Rejected',
        Approved: 'Approved'
      },
      groupByValue: [],
      groupByText: []
    }
  },
  mounted () {
    this.getHistory()
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    headers () {
      return [
        {
          text: 'Employee',
          value: 'Request_Owner',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: this.showListEmployee
        },
        {
          text: 'Created',
          value: 'Date_Of_Create',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Updated',
          value: 'Date_Of_Update',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Compensation Type',
          value: 'Expenditure_Compensation_Type',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: !this.filterBySubcategory
        },
        {
          text: 'Payment Check',
          value: 'Payment_File_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Agreement Document',
          value: 'Agreement_File_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Confirmer',
          value: 'Confirmer_Full_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: !this.fromRequestModule
        },
        {
          text: 'Amount',
          value: 'Amount',
          width: '5%',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Accural Month',
          value: 'Payout_Month',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Status',
          value: 'Is_Pending',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Approved',
          value: 'Approved',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Manage',
          value: 'Edit_Manage',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: !this.fromRequestModule
        },
        {
          text: 'Manage',
          value: 'Manage',
          class: 'px-2 text-center',
          width: '50px',
          sortable: false,
          show: this.fromRequestModule
        }
      ].filter(item => item.show)
    },
    filteredHistory () {
      if (this.filterBySubcategory) {
        const filterBy = this.filterBySubcategory.replace(/Benefit /g, '')
        return this.history.filter(item => item.Expenditure_Compensation_Type === filterBy)
      } else {
        return this.history
      }
    }
  },
  methods: {
    getHistory () {
      const historyOfEmployee = this.showListEmployee ? 'none' : this.employeeId || this.user.employee_id
      this.axios.get(`/api/requests/expenditure_compensation/${historyOfEmployee}` +
        (this.dateFrom ? `/${this.dateFrom}` : '') +
        (this.dateTo ? `/${this.dateTo}` : ''), {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.history = res.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    customGroupBy (items, groupBy) {
      const groups = []
      items.forEach(item => {
        let cId = ''
        for (let i = 0; i < groupBy.length; i++) {
          cId += item[groupBy[i]]
        }
        const group = groups.find(g => g.name === cId)
        if (group) {
          group.items.push(item)
        } else {
          groups.push({
            name: cId,
            items: [item]
          })
        }
      })
      return groups
    },
    totalAmount (items) {
      return items.reduce((total, item) => {
        return total + item.Amount
      }, 0)
    },
    groupTitle (item) {
      let str = ''
      for (let i = 0; i < this.groupBy.length; i++) {
        str += item[this.groupBy[i].value] ? item[this.groupBy[i].value] + (i === this.groupBy.length - 1 ? '' : ', ') : 'Other' + (i === this.groupBy.length - 1 ? '' : ', ')
      }
      return str
    },
    linkToFile (data, type) {
      let res = ''
      let binary = ''
      const bytes = new Uint8Array(data)
      const len = bytes.byteLength
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      res = `data:${type};base64, ${window.btoa(binary)}`
      return res
    },
    openFile (filename, data, type) {
      const linkSource = this.linkToFile(data, type)
      this.downloadLink.href = linkSource
      this.downloadLink.download = filename
      this.downloadLink.click()

      setTimeout(() => {
        this.downloadLink.href = ''
      })
    },
    getCompensationFile (filename, requestId, kindOfFile, mimetype) {
      this.axios.get(`/api/requests/expenditure_compensation_files/${requestId}/${kindOfFile}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.openFile(filename, res.data[0].File.data, mimetype)
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    openRejectDialog (item) {
      this.consideringRequest = item
      this.showRejectDialog = true
    },
    openPendingDialog (item) {
      this.consideringRequest = item
      this.showPendingDialog = true
    },
    openAcceptDialog (item) {
      this.consideringRequest = item
      this.showAcceptDialog = true
    },
    openDeleteDialog (item) {
      this.consideringRequest = item
      this.showDeleteDialog = true
    },
    openRequest (item) {
      this.requestForExpenditureCompensationId = item.Request_ID
      this.requestForExpenditureCompensationDialog = true
    },
    deleteRequest () {
      this.axios.delete(`/api/requests/expenditure_compensation/${this.consideringRequest.Request_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.$store.dispatch('setSuccess', { successMsg: 'Request was deleted' })
        this.getHistory()
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      }).finally(() => {
        this.requestForRefundDialog = false
      })
    },
    sendEmailForBenefitRequest (requestId) {
      const body = {
        Request_ID: requestId
      }
      this.axios.post('/api/emails/sendemailforbenefitrequest', body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.$store.dispatch('setSuccess', { successMsg: 'Email sent' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message })
      })
    },
    considerRequest (approved) {
      if (approved) {
        this.consideringRequest.Rejection_Reason = null
        this.consideringRequest.Approved = 1
        this.consideringRequest.Status = this.statusNames.Approved
        this.consideringRequest.Is_Pending = 0
      } else if (this.pendingReason) {
        this.consideringRequest.Rejection_Reason = this.pendingReason
        this.consideringRequest.Approved = 0
        this.consideringRequest.Payout_Month = null
        this.consideringRequest.Is_Pending = 1
        this.consideringRequest.Status = this.statusNames.Pending
      } else {
        this.consideringRequest.Rejection_Reason = this.rejectionReason
        this.consideringRequest.Approved = 0
        this.consideringRequest.Is_Pending = 0
        this.consideringRequest.Status = this.statusNames.Rejected
      }
      this.consideringRequest.Confirmer_Full_Name = this.user.full_name
      this.consideringRequest.Date_Of_Update = new Date().toISOString().substr(0, 10)

      this.axios.put(`/api/requests/consider_expenditure_compensation/${this.consideringRequest.Request_ID}`,
        {
          Approved: this.consideringRequest.Approved,
          Rejection_Reason: this.consideringRequest.Rejection_Reason,
          Confirmer_ID: this.user.employee_id,
          Creator_ID: this.consideringRequest.Creator_ID,
          Is_Pending: this.consideringRequest.Is_Pending
        },
        {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(() => {
        this.$store.dispatch('setSuccess', { successMsg: 'Request was ' + (approved ? 'approved' : this.consideringRequest.Is_Pending ? 'moved to pending' : 'rejected') })
        this.showAcceptDialog = this.showRejectDialog = this.showPendingDialog = false
        this.$emit('actionOnRequest', {
          approved,
          requestOwner: this.consideringRequest.Creator_ID,
          subCategory: this.filterBySubcategory || 'Benefit ' + this.consideringRequest.Expenditure_Compensation_Type
        })
        this.sendEmailForBenefitRequest(this.consideringRequest.Request_ID)
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    updatePayoutMonth (item) {
      this.axios.put(`/api/requests/expenditure_compensation_payout_month/${item.Request_ID}`,
        {
          Payout_Month: item.Payout_Month
        },
        {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Payout month updated' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  },
  watch: {
    showRejectDialog (val) {
      if (!val) {
        this.rejectionReason = null
      }
    },
    showPendingDialog (val) {
      if (!val) {
        this.pendingReason = null
      }
    },
    groupBy: {
      handler (val, oldVal) {
        this.groupByValue = val.map(el => el.value)
        this.groupByText = val.map(el => el.text)
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.margin-top--10 {
  margin-top: -10px;
}
::v-deep {
  tr:has(.group-td) {
    height: auto !important;
    border-bottom: 2px solid white;
  }
}
</style>
